/* globals $ */
(function() {
    'use strict';

    angular
        .module('quantixApp')
        .directive('togglecontainer', togglecontainer);

    function togglecontainer () {
        var directive = {
            replace: true,
            restrict: 'E',
            transclude: true,
            controller: function () {
            	this.title = 'More';
            	this.opened = false;            	
            	this.toggle = toggle;
            	
            	function toggle(){
            		this.opened = !this.opened
            		
                	if(this.opened){
                		this.title = 'Less';
                	}else{
                		this.title = 'More';
                	}
            	}
            	
              },
              controllerAs: 'ctrl',
            template: ' <div class="collapsible"> '+   
            	'<div ng-transclude ng-show="ctrl.opened"></div>'+
            	'<div class="col-md-12 margin-bottom-10" id="about"><a href="" ng-click="ctrl.toggle()" class="btn btn-outline-primary btn-sm expander">{{ctrl.title}}</a> </div>'+
                 '</div>'
        };

        return directive;
        
    }
})();
